import { Box, Stack } from "@chakra-ui/react";
import { getCdnImageSrc, Image, VStack, responsive, colors } from "goi_common";
import { ReactNode } from "react";

export default function DisposalBenefitSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.black}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack
          width="100%"
          css={responsive({
            alignItems: { base: "center", lg: "flex-start" },
            marginBottom: "40px",
          })}
          gap="16px"
        >
          <Box
            className="white head_28_b lg_head_42_b"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            30박스 소량제작부터,
            <br className="lg_over_hidden" /> 필요한 옵션추가까지 자유롭게
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_r"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            더 이상 상조용품 제작 고민하지 마세요
            <br />
            담당자가 찾아뵙고 하나부터 열까지 모두 다 가이드해드립니다
          </Box>
        </VStack>
        <BenefitItem
          num={1}
          title={"30박스부터 소량 제작이 가능해요"}
          description={
            <>
              30박스부터 소량 제작이 가능하며
              <br />
              임직원 숫자에 비례해서 제작 박스 숫자를 안내해드려요
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "40%" },
            height: { base: "100%", lg: "230px" },
          }}
        />
        <BenefitItem
          num={2}
          title={"얼마든지 필요에 따라 옵션을 추가해요"}
          description={
            <>
              예상 조문객 수에 따라 선택적으로 가능해요. (200인분/300인분)
              <br />
              기타 물품 추가가 가능해요 (근조기, 슬리퍼, 칫솔/치약, 여행용세트
              등)
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "30%" },
            height: { base: "100%", lg: "300px" },
          }}
        />
      </VStack>
    </VStack>
  );
}

function BenefitItem({
  num,
  title,
  imageSize,
  description,
}: {
  num: number;
  title: string;
  imageSize: {
    width: { base: string; lg: string };
    height: { base: string; lg: string };
  };
  description: ReactNode;
}) {
  return (
    <Stack
      gap="16px"
      justifyContent="space-between"
      css={responsive({
        flexDirection: { base: "column", lg: "row" },
        padding: { base: "24px", lg: "52px 48px" },
        borderRadius: "16px",
      })}
      background={colors.gray100}
      overflow="hidden"
    >
      <VStack
        justifyContent="center"
        css={responsive({
          width: { base: "100%", lg: "50%" },
        })}
      >
        <Box className="orange650 subtitle_18_b lg_head_24_b">0{num}</Box>
        <Box
          className="gray900 head_24_b lg_head_32_b"
          css={responsive({
            whiteSpace: "pre-line",
            padding: { base: "8px 0 10px", lg: "16px 0 20px" },
          })}
        >
          {title}
        </Box>

        <Box
          className="gray600 body_14_r lg_subtitle_21_r"
          css={{ wordBreak: "keep-all" }}
        >
          {description}
        </Box>
      </VStack>
      <VStack
        borderRadius="16px"
        css={responsive(imageSize)}
        justifyContent="center"
      >
        <Image
          src={getCdnImageSrc(`b2b/disposal/benefit-1-${num}.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </VStack>
    </Stack>
  );
}
